import { ThunkType } from "../../../../core/store/reducers";
import deleteCountryApi from "../api/deleteCountry";
import { setFetchState } from "../countriesDataReducer";

export const deleteCountry = (cntId: string): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = await dispatch(deleteCountryApi(userId, cntId));

  dispatch(
    setFetchState(
      result !== undefined ? { type: "successful" } : { type: "error" }
    )
  );
};
